<script setup lang="ts">
import { computed, ref } from "vue";
import ScaleMenuState from "@/stores/ScaleMenuState";
import ScaleList from "./ScaleList.vue";
import ScaleChipContent from "./ScaleChipContent.vue";
import { useHeaderPopoverLock } from "@/composable/useHeaderPopoverLock";

/**
 * Échelle active (style de texte de la légende), dans l'en-tête juste après la
 * légende. Masquée quand la légende n'en définit aucune : on afficherait sinon
 * le nom technique de l'échelle par défaut.
 */
const activeScaleName = computed(() => ScaleMenuState.activeScale?.name ?? "-");

const popoverLock = useHeaderPopoverLock();

const popoverRef = ref<{ hide: () => void } | null>(null);
const listRef = ref<InstanceType<typeof ScaleList> | null>(null);

function onShow() {
  popoverLock.onShow();
  listRef.value?.revealActive();
}
</script>

<template>
  <el-popover
    v-if="ScaleMenuState.scales.length"
    ref="popoverRef"
    placement="bottom-start"
    :width="280"
    trigger="click"
    effect="dark"
    :show-arrow="false"
    popper-class="legend-settings-popover scale-list-popover"
    @show="onShow"
    @hide="popoverLock.onHide"
  >
    <template #reference>
      <button
        type="button"
        class="canvas-header-chip"
        :aria-label="`${$t('canvas:header.scale.label')} : ${activeScaleName}`"
      >
        <ScaleChipContent />
      </button>
    </template>

    <ScaleList ref="listRef" @selected="popoverRef?.hide()" />
  </el-popover>
</template>
